import { toast } from "react-toastify";

export const logout = () => {
  sessionStorage.removeItem("userData");
  sessionStorage.removeItem("engageData");
  toast.warning("Your login session is expired");
  setTimeout(() => {
    window.location.replace("/"); // Redirect to login
  }, 1000);
};
